module.exports = ".sub-spec-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  .sub-spec-form mat-form-field {\n    width: calc(50% - 10px); }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-sub-spec-form/product-sub-spec-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-sub-spec-form/product-sub-spec-form.component.scss
// module chunks = main